import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Update } from '@ngrx/entity';
import { Store } from '@ngrx/store';

import { of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, tap } from 'rxjs/operators';

import { environment } from '../../../../environments/environment';

import { State } from '../../vista-usuario/vista-usuario.state';
import {
  entityRolesActividadAddFailure,
  entityRolesActividadAddRequest,
  entityRolesActividadAddSuccess,
  entityRolesActividadLoadFailure,
  entityRolesActividadLoadRequest,
  entityRolesActividadLoadSuccess,
  entityVinculacionesRolActividadChangeFailure,
  entityVinculacionesRolActividadChangeRequest,
  entityVinculacionesRolActividadChangeSuccess
} from './entity-roles-actividad.actions';

import { RolesActividadService } from '@rpe/registro-personas-empresas-lib';
import { RolActividad } from '@rpe/registro-personas-empresas-lib/src/projects';
import { entityRolChangeSuccess } from '../entity-roles/entity-roles.actions';
import { Rol } from '../entity-roles/roles.model';

@Injectable()
export class RolesActividadEffects {
  // load
  loadRequestRolesActividad = createEffect(() =>
    this.actions$.pipe(
      ofType(entityRolesActividadLoadRequest),
      mergeMap(() =>
        this.rolesActividadService.getRolesActividad().pipe(
          map((items) => entityRolesActividadLoadSuccess({ items })),
          catchError((error) => of(entityRolesActividadLoadFailure({ error })))
        )
      )
    )
  );

  // add
  addRequestRolesActividad = createEffect(() =>
    this.actions$.pipe(
      ofType(entityRolesActividadAddRequest),
      switchMap((action) =>
        this.rolesActividadService.addRolesActividad(action.item).pipe(
          map((item) => entityRolesActividadAddSuccess({ item })),
          catchError((error) => of(entityRolesActividadAddFailure({ error })))
        )
      )
    )
  );

  addSuccessRolesActividad = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityRolesActividadAddSuccess),
        tap(() => this.router.navigate(['']))
      ),
    { dispatch: false }
  );

  // change vinculaciones
  changeRequestVinculacionesRolActividad = createEffect(() =>
    this.actions$.pipe(
      ofType(entityVinculacionesRolActividadChangeRequest),
      switchMap((action) =>
        this.rolesActividadService
          .changeVinculacionesRolActividad(action.item)
          .pipe(
            map((item: { rolesActividad: RolActividad[] }) => {
              const rolId = item.rolesActividad[0].rol_id;
              const updates: Update<RolActividad>[] = [];
              item.rolesActividad.forEach((rolActividad) => {
                updates.push({ id: rolActividad.id, changes: rolActividad });
              });
              return entityVinculacionesRolActividadChangeSuccess({
                item: updates,
                rolId: rolId
              });
            }),
            catchError((error) =>
              of(entityVinculacionesRolActividadChangeFailure({ error }))
            )
          )
      )
    )
  );

  changeSuccessVinculacionesRolActividad = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityVinculacionesRolActividadChangeSuccess),
        map((action) => {
          /* this.notification.success(
            'Vinculación realizada con exito.'
          )*/
          return entityRolChangeSuccess({ item: { vinculo_aprobado_rol: true } as Rol });
        })
      ),
    { dispatch: true }
  );

  /* this.rolService.changeRol(action.item).pipe(
          map((itemaux: Rol) => {
            // console.log(itemaux, 'itemaux');
            const item: Update<Rol> = {
              id: itemaux.id,
              changes: itemaux
            };
            return entityRolChangeSuccess({ item });
          }), */

  addSuccessVinculacionesRolActividad = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityVinculacionesRolActividadChangeSuccess),
        tap(() => this.router.navigate(['']))
      ),
    { dispatch: false }
  );

  // delete

  constructor(
    private actions$: Actions,
    private store: Store<State>,
    private rolesActividadService: RolesActividadService,
    private router: Router
  ) {
    this.rolesActividadService.url = environment.apiUrl;
  }
}
